import { useConvexAuth, useQuery } from "convex/react";
import { api } from "@repo/backend/api";
import { useAuthToken } from "@convex-dev/auth/react";

export const useAuth = () => {
  const { isLoading, isAuthenticated } = useConvexAuth();
  const user = useQuery(api.auth.getUser);
  const token = useAuthToken();

  return {
    token,
    isLoading,
    isAuthenticated,
    user,
  };
};
